<script lang="ts">
  import UnAuthedUserTopBarPage from '../../Navigation/TopLevelPages/NoSubscriptionUserTopBarPage.svelte'
  import { goto } from '@roxi/routify'
  import { sendEventToFirebase } from '../../logging/events'
  import { onMount } from 'svelte'
  import { authed_user } from '../../Users/observables'
  import CtaButton from '../../Generic/CtaButton.svelte'
  onMount(() => {
    const sub = authed_user.subscribe(user => {
      sendEventToFirebase({
        key: 'SuccessfulCheckout',
        organization: user.organization,
      })
    })
    return () => sub.unsubscribe()
  })
</script>

<UnAuthedUserTopBarPage>
  <div id="container">
    <p>Thanks for trying out the TSF Retro App!</p>
    <div id="cards-desc">
      <p>You can change your Retro cards before your first session here:</p>
      <span><CtaButton on:click={() => void $goto('/cards')}>Edit Cards</CtaButton></span>
    </div>
  </div>
</UnAuthedUserTopBarPage>

<style>
  #container {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    height: 80vh;
  }

  #cards-desc {
    display: flex;
    flex-flow: row nowrap;
    align-items: baseline;
  }

  #cards-desc > span {
    margin: 0em 2em;
  }
</style>
